import * as React from 'react';

import { IDocument, ITagline } from '../../infrastructure/interfaces';
import Radio from '../Radio';

export interface ITaglineEditorFormProps {
  document: IDocument;
  taglines: ITagline[];
  onTaglineChange(title: string): void;
  className: string;
}

export default class TaglineEditorForm extends React.Component<ITaglineEditorFormProps> {

  render() {
	return (
	  <div className={this.props.className}>
		{this.props.taglines.map((tagline) => (
		  <div key={tagline.title} className="rowStepTwo">
			<Radio
			  checked={(this.props.document.title === tagline.title)}
			  onChange={() => this.props.onTaglineChange(tagline.title)}
			>
			  <div className="image-box">
				<span>{tagline.title.replace(/<br\/>/g, " ")}</span>
			  </div>
			</Radio>
		  </div>
		))}
	  </div>
	);
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentEditor/TaglineEditorForm.tsx